<template>
    <div>
        <h1 :class="selected ? 'text-sm pt-2' : 'text-xl pt-0.5 font-bold'">
            {{$t('form.relais.point_relais')}}
        </h1>
        <sav-fold-card
        v-model="open"
        class="mt-4"
        :close-button="false"
        :id="$options.name"
        :can-open="canOpen"
        >
            <template v-slot:close>
                <template v-if="selected">
                    <div class="text-sm font-bold">{{selected.data.nom}}</div>
                    <div class="text-xs font-light">{{selected.data.adresse + ' ' + selected.data.cp + ' ' + selected.data.ville}}</div>
                </template>
            </template>

            <template v-slot:open>
                <sav-spinner class="mt-4" v-if="loading" :size="10" />

                <div :class="selectedRelais ? '' : 'lg:flex'">
                    <div class="p-2 pl-0" :class="selectedRelais ? '' : 'lg:w-1/2'">
                        <div ref="leftSide" :style="selectedRelais ? '' : 'max-height: 400px; overflow-y: auto'">
                            <!-- No relais -->
                            <div class="p-4 font-light text-white bg-red-600 rounded-xl" v-if="data && data.length <= 0">
                                <i class="mr-2 fas fa-triangle-exclamation"></i> Aucun poit relais n'a été trouvé
                            </div>

                            <!-- Relais list -->
                            <div class="animate__slideInLeft animate__animated animate__faster" v-if="!selectedRelais">
                                <div
                                v-for="(marker, markerIndex) in markers"
                                :key="'marker-' + markerIndex"
                                class="duration-200 border-b-4 border-gray-200 rounded cursor-pointer hover:bg-gray-100"
                                >                            
                                    <!-- Relai card -->
                                    <div
                                    @mouseover="selectedMarker = marker"
                                    @mouseleave="selectedMarker = null"
                                    v-if="marker && marker.data"
                                    @click.stop="selectMarker(marker)"
                                    class="px-3 py-4"
                                    >
                                        <div class="text-sm font-bold">{{marker.data.nom}}</div>
                                        <div class="xl:flex xl:items-center" :class="marker.data.distance ? 'mt-1.5 mb-1' : ''">
                                            <div>
                                                <sav-distance v-if="marker.data.distance" :label="false" :distance="marker.data.distance" />
                                                <div v-if="marker.data.accompte && marker.data.accompte > 0" class="pt-2 mt-1 text-xs font-bold text-red-500 xl:mt-0">
                                                    Accompte: {{marker.data.accompte}}€
                                                    <div class="text-xs font-light" v-if="marker.data.total > 0">
                                                        <div v-if="marker.data.mo > 0">Main d'oeuvre: {{marker.data.mo}}€</div>
                                                        <div v-if="marker.data.deplacement > 0">Déplacement: {{marker.data.deplacement}}€</div>
                                                        <div v-if="marker.data.devis_ref > 0">Devis refusé: {{marker.data.devis_ref}}€</div>
                                                    </div>
                                                    <div class="pt-2 mt-2 text-xs font-light border-t border-gray-200" v-if="marker.data.comment">{{marker.data.comment}}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- Relai Informations -->
                            <div v-if="selectedRelais">
                                <!-- Nom -->
                                <div class="pb-3 mb-3 border-b">
                                    <div class="items-center justify-between">
                                        <div>
                                            <div class="text-xl font-bold">{{selectedRelais.data.nom}}</div>
                                            <div class="text-xs font-light">{{selectedRelais.data.distance}}</div>
                                        </div>
                                        <div class="flex mt-3">
                                            <button class="px-5 py-2.5 text-sm font-base text-white duration-100 duration-200 bg-green-600 border-green-600 hover:bg-green-700 rounded-xl font-extrabold mr-2" @click="end(selectedRelais)" test-id="btn-submit">
                                                <i class="mr-1 fas fa-check"></i> Confirmer le relais
                                            </button>
                                            <button class="px-5 py-2.5 text-sm font-base text-white duration-100 duration-200 bg-red-600 border-red-600 hover:bg-red-700 text-white font-extrabold rounded-xl opacity-80 hover:opacity-100 duration-200" @click="selectedRelais = null" test-id="btn-submit">
                                                <i class="mr-1 fas fa-times"></i> Annuler
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                <template v-if="!canDisplayRelaisInfos">
                                    <sav-spinner class="mt-4" :size="10" />
                                </template>
                                <template v-if="canDisplayRelaisInfos">
                                    <!-- map -->
                                    <div class="mt-4">
                                        <div class="text-sm font-bold">
                                            <i class="mr-1 fas fa-location-dot"></i> Emplacement
                                        </div>
                                        <sav-map
                                        class="w-full mt-2 mb-5"
                                        height="250"
                                        custom-class="shadow my-rounded"
                                        v-if="selectedRelais"
                                        :home="address ? {
                                            longitude: address.longitude,
                                            latitude: address.latitude
                                        } : null"
                                        :position="{
                                            longitude: selectedRelais.longitude,
                                            latitude: selectedRelais.latitude,
                                            zoom: zoom
                                        }"
                                        :markers="[selectedRelais]"
                                        @marker-clicked="markerClicked"
                                        ></sav-map>
                                    </div>

                                    <!-- Horaires -->
                                    <div class="mt-4">
                                        <div class="text-sm font-bold">
                                            <i class="mr-1 fas fa-clock"></i> Horaires
                                        </div>
                                        <div class="p-5 mt-2 border rounded-xl">
                                            <small class='flex items-center justify-between'>
                                                <div>Lundi</div>
                                                <div class="font-bold">
                                                    {{displayHoraire(selectedRelais.data.horaire['Lundi'].string) || '-'}}
                                                </div>
                                            </small>
                                            <small class='flex items-center justify-between'>
                                                <div>Mardi</div>
                                                <div class="font-bold">
                                                    {{displayHoraire(selectedRelais.data.horaire['Mardi'].string) || '-'}}
                                                </div>
                                            </small>
                                            <small class='flex items-center justify-between'>
                                                <div>Mercredi</div>
                                                <div class="font-bold">
                                                    {{displayHoraire(selectedRelais.data.horaire['Mercredi'].string) || '-'}}
                                                </div>
                                            </small>
                                            <small class='flex items-center justify-between'>
                                                <div>Jeudi</div>
                                                <div class="font-bold">
                                                    {{displayHoraire(selectedRelais.data.horaire['Jeudi'].string) || '-'}}
                                                </div>
                                            </small>
                                            <small class='flex items-center justify-between'>
                                                <div>Vendredi</div>
                                                <div class="font-bold">
                                                    {{displayHoraire(selectedRelais.data.horaire['Vendredi'].string) || '-'}}
                                                </div>
                                            </small>
                                            <small class='flex items-center justify-between'>
                                                <div>Samedi</div>
                                                <div class="font-bold">
                                                    {{displayHoraire(selectedRelais.data.horaire['Samedi'].string) || '-'}}
                                                </div>
                                            </small>
                                            <small class='flex items-center justify-between'>
                                                <div>Dimanche</div>
                                                <div class="font-bold">
                                                    {{displayHoraire(selectedRelais.data.horaire['Dimanche'].string) || '-'}}
                                                </div>
                                            </small>
                                        </div>
                                    </div>

                                    <!-- Adresse -->
                                    <div class="mt-4">
                                        <div class="text-sm font-bold">
                                            <i class="mr-1 fas fa-home"></i> Adresse
                                        </div>
                                        <div class="p-5 mt-2 text-xs border rounded-xl">
                                            <div>{{selectedRelais.data.adresse}}</div>
                                            <div>{{selectedRelais.data.ville + ', ' + selectedRelais.data.cp}}</div>
                                        </div>
                                    </div>
                                </template>
                            </div>
                        </div>
                    </div>

                    <!-- Right map -->
                    <sav-map
                    class="hidden block mt-3 lg:block lg:w-1/2"
                    custom-class="shadow my-rounded"
                    v-if="!selectedRelais && markers && markers.length > 0"
                    :position="{
                        longitude: longitude,
                        latitude: latitude,
                        zoom: zoom
                    }"
                    :home="address ? {
                        longitude: address.longitude,
                        latitude: address.latitude
                    } : null"
                    :markers="markers"
                    :selected-marker="selectedMarker"
                    :selected-marker-zoom="14"
                    @marker-clicked="markerClicked"
                    ></sav-map>
                </div>
            </template>
        </sav-fold-card>            
    </div>
</template>



<script>
import apiService from '@/services/api.service'

import FormCardExtension from '@/extends/FormCardExtension'
import eventHub from '@/eventHub'
import SavDistance from '@/components/SavDistance.vue'

export default {
  components: { SavDistance },
    name: 'get-relais',
    extends: FormCardExtension,

    data() {
        return {
            markers: null,
            longitude: null,
            latitude: null,
            zoom: 14,

            selectedRelais: null,
            canDisplayRelaisInfos: false,
            address: null,

            selectedMarker: null
        }
    },

    methods: {
        async init() {
            this.markers = []
            this.longitude = "2.213749"
            this.latitude = "46.227638"

            // Check if data
            if (this.$formTool.getFormData(this.$options.name)) {
                this.selected = JSON.parse(JSON.stringify(this.$formTool.getFormData(this.$options.name)))
                this.selectedRelais = this.selected
                this.canDisplayRelaisInfos = true
                this.nextBlock = await this.getNextBlock()
                this.emitChange()
            }

            this.address = this.$formTool.getFormData('client-address')
            let response = await apiService.post('getrelais', {
                id_adresse: this.address ? this.address.id : null
            })
            this.data = response.data.posts.post

            if (this.data.length <= 0) {
                this.$toast.error('Aucun point relais trouvé')
                this.$parent.removeLastBlock()
                eventHub.$emit('init-type-delivery')
            }

            let makeid = (length) => {
                var result = ''
                var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
                var charactersLength = characters.length
                for (var i = 0; i < length; i++) {
                    result += characters.charAt(Math.floor(Math.random() * charactersLength))
                }
                return result
            }

            this.longitude = this.data[0].lng.replace(',', '.')
            this.latitude = this.data[0].lat.replace(',', '.')
            this.data.forEach((item, index) => {
                if (item.lng && item.lat) {
                    this.data[index].map_id = index
                    this.markers.push({
                        longitude: item.lng.replace(',', '.'),
                        latitude: item.lat.replace(',', '.'),
                        data: item,
                        type: item.type,
                        color: null,
                        map_id: index,
                        label: `
                        <div class="font-bold">${item.nom}</div>
                        `,
                        id: makeid(20)
                    })
                }
            })

            this.loading = false
        },

        async end(callbackData) {
            this.nextBlock = await this.getNextBlock()

            let response = await apiService.post('setrelais', {
                id_relais: callbackData.id,
                id_case: JSON.parse(this.$formTool.getFormData('set-case')).id_case
            })

            this.$formTool.addFormData('relais', response.data.posts.post)
            this.$formTool.addFormData(this.$options.name, callbackData)

            if (this.selected) {
                this.$emit('update', this.$options.name)
            }
            this.selected = JSON.parse(JSON.stringify(callbackData))
            if (this.manualAddress) {
                this.saveAddressInAccount()
            }
        },

        async getNextBlock() {
            let responseAmount = await apiService.post('get_amount', {
                id_case: JSON.parse(this.$formTool.getFormData('set-case')).id_case
            })

            let amountData = responseAmount.data.posts.post

            if (Number(amountData.montant_total) == 0 || Number(amountData.montant_total) == Number(amountData.montant_already_paid)) {
                return this.$formTool.blockData(this.$options.name).next.free
            } else {
                return this.$formTool.blockData(this.$options.name).next.pay
            }
        },

        displayHoraire(horaire) {
            let addHourLabel = (hour) => {return hour.slice(0, 2) + "h" + hour.slice(2)}
            
            if (horaire) {
                if (horaire.reduce((a, b) => Number(a) + Number(b), 0) == 0) {
                    return 'Fermé'
                } else if (horaire.slice(Math.max(horaire.length - 2, 1)).reduce((a, b) => Number(a) + Number(b), 0) == 0) {
                    return addHourLabel(horaire[0]) + '-' + addHourLabel(horaire[1])
                } else {
                    return addHourLabel(horaire[0]) + '-' + addHourLabel(horaire[1]) + ', ' + addHourLabel(horaire[2]) + '-' + addHourLabel(horaire[3])
                }
            }
        },

        markerClicked(marker) {
            this.selectMarker(marker)
        },

        selectMarker(marker) {
            if (marker.data) {
                this.selectedRelais = marker
                this.$refs.leftSide.scrollTop = 0
                this.canDisplayRelaisInfos = false
    
                setTimeout(() => {
                    this.canDisplayRelaisInfos = true
                }, 1000)
            }
        }
    },

    mounted() {
        this.init()
    }
}
</script>



// WEBPACK FOOTER //
// src/processes/cards/procedure/Components/GetRelaisCard.vue